module.exports = __webpack_public_path__ + "static/media/drew-delong-resume.1db3f615.pdf";